import { setGoodSize } from "./domUtils";
import { SendData } from "./SendData";

/**
 * Создает скрытый iframe и выполняет печать содержимого элемента или указанного шаблона с возможностью замены.
 *
 * @param {string|HTMLElement} elem Идентификатор или сам элемент, содержимое которого нужно напечатать.
 * @param {Object} data Объект с параметрами печати, включая заголовок и правила замены содержимого.
 */
export async function PrintElem({
  url = null,
  selector = null,
  triger = null,
  elem = null,
  bootstrap = true,
  testPrint = false,
  setGoodSizeParam = {
    elem: [],
    size: 14,
    func: null,
  },
  title = 'bill',
  replaceElem = null,
  loading = null,
  validate = false,
  data = {},
}) {
  if (validate) {
    if (validate instanceof Function) {
      if (!validate()) return; // Если данные невалидны, функция завершится
    } else if (typeof validate === 'string' || validate === true) {
      const closestForm = elem.closestParentWith('form');
      if (closestForm) {
        const resultValidate = await validateForm({ elem: closestForm });
        if (!resultValidate) return; // Если данные невалидны, функция завершится
      } else {
        throw new Error('Не найдено родительской формы для валидации');
      }
    }
  }
  return new Promise(async (resolve, reject) => {
    if (url) {
      if (loading) {
        LoadingManager.show(loading);
      }
      try {
        const urlResponse = await new SendData({ url: url, data, elem: triger ?? elem, messageAuto: true });
        if (urlResponse.status !== 200) {
          reject({ status: urlResponse.status, message: urlResponse.message ?? 'Ошибка получения шаблона для печати' });
          return;
        }
        if (typeof urlResponse.answer === 'string' && urlResponse.answer.trim() !== '') {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = urlResponse.answer;
          elem = tempDiv;
        } else {
          reject({ status: 500, message: 'Ошибка получения шаблона для печати' });
          return;
        }
      } catch (error) {
        reject({ status: 500, message: 'Ошибка получения шаблона для печати' });
        return;
      } finally {
        if (loading === false) {
          LoadingManager.hide();
        }
      }
    } else {
      if (typeof elem === 'string') {
        elem = document.querySelector(selector ?? elem);
      } else if (typeof elem === 'object' && elem === null) {
        let parentNode = triger;
        do {
          parentNode = parentNode.parentNode; // Перемещаемся вверх по DOM
          if (parentNode) {
            elem = parentNode.querySelector('[data-print="this"]'); // Пытаемся найти нужный элемент
          }
        } while (parentNode && !elem); // Продолжаем, пока не найдем элемент или не достигнем корня
      }
    }

    // Создаем скрытый iframe вместо нового окна
    var iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.classList.add('PrintElem');
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    document.body.appendChild(iframe);
    const lastTitle = document.querySelector('title').innerText;
    document.querySelector('title').innerText = title;

    const print = (response) => {
      var doc = iframe.contentWindow.document;
      doc.write(`<!DOCTYPE html><html><head><meta charset="UTF-8">
      <meta http-equiv="X-UA-Compatible" content="IE=edge">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>${title}</title></head>`);
      // <link href='http://fonts.googleapis.com/css?family=Roboto' rel='stylesheet' type='text/css'>
      var style = doc.createElement('style');
      style.innerHTML = response.answer;
      // console.log(style);
      doc.head.appendChild(style);
      var template = document.createElement('div');
      template.innerHTML = elem.innerHTML;

      if (replaceElem) {
        template.querySelector(replaceElem.selector).innerHTML = replaceElem.replace;
      }
      template.querySelectorAll('script').forEach((script) => script.remove());
      doc.write('<body><div id="bill">');
      doc.write(template.innerHTML);
      doc.write('</div></body></html>');
      doc.close();

      // Печать после полной загрузки iframe
      iframe.onload = function () {
        iframe.contentWindow.focus(); // Необходимо для IE >= 10

        setGoodSize(setGoodSizeParam.elem, setGoodSizeParam.size);
        if (setGoodSizeParam.func) {
          setGoodSizeParam.func(doc);
        }
        if (testPrint) {
          document.body.closest('html').innerHTML = doc.body.innerHTML;
          return;
        }
        setTimeout(function () {
          iframe.contentWindow.print();
          document.querySelector('title').innerText = lastTitle;
        }, 100);

        setTimeout(function () {
          resolve({ status: 200 });
          document.body.removeChild(iframe); // Удаление iframe после печати
        }, 200);
      };
    };

    if (!bootstrap) {
      print({ answer: '' });
      return;
    }
    new window.SendData({
      data: {},
      url: '/assets/bootstrap/css/bootstrap.min.css'
    }).then(print);
  })
}
